import { Outlet, useParams } from "react-router";
import { CalendarCheck, Home, MessageCircle, Scissors } from "lucide-react";
import { Banner } from "@astryxdesign/core/Banner";
import { VStack } from "@astryxdesign/core/VStack";
import { BottomNav, type NavItem } from "@/components/layout/BottomNav";
import { useStudio } from "@/features/studio/StudioRoot";
import { BookingSheet } from "@/features/booking/BookingSheet";
import { useT } from "@/lib/i18n";

export function ClientLayout() {
  const { slug = "" } = useParams();
  const studio = useStudio();
  const t = useT();
  const base = `/s/${slug}`;
  const items: NavItem[] = [
    { to: base, label: t.nav.home, icon: Home, end: true },
    { to: `${base}/services`, label: t.nav.services, icon: Scissors },
    { to: `${base}/my`, label: t.nav.bookings, icon: CalendarCheck },
    ...(studio.ai_enabled ? [{ to: `${base}/assistant`, label: t.nav.assistant, icon: MessageCircle }] : []),
  ];
  return (
    <>
      {studio.config.is_demo || studio.status === "preview" ? (
        <VStack paddingInline={4} paddingBlockStart={2} className="app-safe-top">
          <Banner
            status="info"
            container="card"
            title={studio.config.is_demo ? t.studio.demoTitle : t.studio.previewTitle}
            description={
              studio.config.is_demo ? t.studio.demoText : t.studio.previewText
            }
            collapsible={false}
          />
        </VStack>
      ) : null}
      <Outlet />
      <BookingSheet />
      <BottomNav items={items} label={t.nav.clientLabel} />
    </>
  );
}
